import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h2`
	color: ${helpers.color.textHeader};
	font-size: ${helpers.font.size.subheader};
	font-family: ${helpers.font.family.header};
	font-weight: 400;
	margin: 6px 0 16px;
`
